<!--
* UI Name: MQ
* Modify Date: 2021/03/03
-->
<template>
  <div>
    <v-form ref="form">
      <v-row>
        <v-col cols="12" md="12" class="py-0">
          <v-row>
            <v-col cols="12" md="6" class="px-2 py-0">
              <v-label><v-icon x-small class="mr-1">fa fa-asterisk</v-icon>Host</v-label>
              <v-text-field
                v-model="formData.host"
                :rules="[
                  validationUtils.required,
                  validationUtils.min(8),
                  validationUtils.max(100),
                ]"
                solo
                :disabled="!$auth.manage"
                :readonly="isHistory"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" class="px-2 py-0">
              <v-label><v-icon x-small class="mr-1">fa fa-asterisk</v-icon>Port</v-label>
              <v-text-field
                v-model="formData.port"
                type="number"
                :rules="[validationUtils.required, validationUtils.max(5)]"
                solo
                :disabled="!$auth.manage"
                :readonly="isHistory"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <!--3 Row 40px-->
      <v-row>
        <v-col cols="12" md="6" class="px-2 py-0">
          <v-label><v-icon x-small class="mr-1">fa fa-asterisk</v-icon>Queue Name</v-label>
          <v-text-field
            v-model="formData.comm_mq_nm"
            :rules="[validationUtils.required, validationUtils.max(50)]"
            solo
            :disabled="!$auth.manage"
            :readonly="isHistory"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6" class="px-2 py-0">
          <v-label>Queue Manager</v-label>
          <v-text-field
            v-model="formData.comm_mq_mgr"
            :rules="
              formData.comm_mq_mgr && formData.comm_mq_mgr.length > 50 ? ['Max 50 characters'] : []
            "
            solo
            :disabled="!$auth.manage"
            :readonly="isHistory"
          ></v-text-field>
        </v-col>
      </v-row>
      <!-- // 05/24/2021 203737 SPKA-115 issue 63 Add interval type in communication component -->
      <v-row>
        <v-col cols="12" md="12" class="px-2 py-0">
          <v-row>
            <v-col cols="12" md="4" class="py-0 pr-1">
              <v-label
                ><v-icon x-small class="mr-1">fa fa-asterisk</v-icon
                >{{ $t('lbl.communications.exeInterval') }}</v-label
              >
              <v-text-field
                v-model="formData.interval"
                type="number"
                :rules="[validationUtils.required, validateInterval(intervalDefault)]"
                solo
                :disabled="!$auth.manage"
                :readonly="isHistory"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4" class="py-0 pr-1">
              <v-select
                v-model="intervalDefault"
                :items="intervals"
                solo
                :menu-props="{ offsetY: true }"
                :disabled="!$auth.manage"
                :readonly="isHistory"
                return-object
                style="margin-top: 22px !important;"
              ></v-select>
            </v-col>
            <v-col cols="12" md="4" class="py-0">
              <v-label>{{ $t('lbl.communications.maxRetryAttempts') }}</v-label>
              <v-text-field
                v-model="formData.maxRetry"
                type="number"
                solo
                :disabled="!$auth.manage"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import EventBus from '@/vue-caas/views/process/component/event-bus.js';
import { getEditData } from '@/vue-caas/utils/process';

export default {
  props: {
    item: {
      type: Object,
    },
    nodeId: {
      type: String,
    },
    isHistory: {
      default: false,
    },
  },

  data() {
    return {
      mqType: [
        { text: 'IBM MQ', value: 'IBM_MQ' },
        { text: 'Active MQ', value: 'ACTIVE_MQ' },
      ],
      formData: {},
      loadFormData: {},
      formError: {
        name: {
          message: '',
        },
      },
      intervals: [
        { text: this.$t('msg.communications.seconds'), value: 'SS' },
        { text: this.$t('msg.communications.minutes'), value: 'MM' },
        { text: this.$t('msg.communications.hours'), value: 'HH' },
      ],
      intervalDefault: {
        text: this.$t('msg.communications.minutes'),
        value: 'MM',
      },
    };
  },

  created() {
    this.resetFormData();
  },

  watch: {
    item() {
      this.resetFormData();
      // this.setFocus();
    },
  },

  methods: {
    checkDataChange() {
      let editedData = getEditData(this.formData, this.loadFormData);
      this.$emit('check-data-change', editedData);
    },
    async save(item) {
      let validResult = this.$refs.form.validate();
      if (!validResult) return -1;
      this.formData.id = item.id;
      this.formData.type = item.type;
      this.formData.name = item.name;
      this.formData.protocol = item.type;
      this.formData.path =
        this.formData.type == 'IBM_MQ'
          ? 'queue://' + this.formData.comm_mq_mgr + '/' + this.formData.comm_mq_nm
          : 'queue://' + this.formData.comm_mq_nm;

      let editedData = getEditData(this.formData, this.loadFormData);
      editedData.id = this.formData.id;
      editedData.name = this.formData.name;
      editedData.protocol = this.formData.type;

      // 05/24/2021 203737 SPKA-115 issue 63 Add interval type in communication component
      if (this.formData.id) {
        await this.$store
          .dispatch('editCommFromProcSetup', this.formData)
          .then(() => {
            this.sendActivate(this.formData.id, 'COM', editedData);
            let formEmit = {
              comId: this.formData.id,
              nodeId: this.nodeId,
              type: 'COM',
            };
            EventBus.$emit('refresh-list-component', formEmit);
          })
          .catch((err) => {
            alert(err);
          });
      } else {
        await this.$store
          .dispatch('insertCommFromProcSetup', this.formData)
          .then(() => {
            this.formData.id = this.$store.getters.communicationId;
            let formEmit = {
              comId: this.formData.id,
              nodeId: this.nodeId,
              type: 'COM',
            };
            EventBus.$emit('refresh-list-component', formEmit);
          })
          .catch((err) => {
            alert(err);
          });
      }
    },
    async sendActivate(comId, comTp, info) {
      const params = {
        comId: comId,
        comTp: comTp,
        info: info,
      };
      await this.$store.dispatch('updateProcessInfo', params);
    },

    getInitData() {
      return {
        name: '',
        partner: '',
        direction: '',
        host: '',
        security: '',
        port: '',
        userid: '',
        password: '',
        path: '',
        interval: '30',
        type: '',
        comm_mq_nm: '',
        comm_mq_mgr: '',
      };
    },
    resetFormData() {
      this.formData = Object.assign({}, this.getInitData(), this.item);
      this.loadFormData = Object.assign({}, this.getInitData(), this.item);
      if (!this.formData.interval) {
        this.formData.interval = '30';
      }

      if (this.item.intervalType) {
        this.intervalDefault = this.intervals.filter(
          (item) => item.value === this.item.intervalType,
        )[0];
      } else {
        this.intervalDefault = {
          text: this.$t('msg.communications.minutes'),
          value: 'MM',
        };
      }
      if (this.$refs.form) this.$refs.form.resetValidation();
    },
    setFieldValidation(name, message) {
      this.formError[name] = {
        message,
      };
    },
    setFocus() {
      setTimeout(() => {
        this.$refs.name.focus();
      }, 300);
    },
    // 05/24/2021 203737 SPKA-115 issue 63 Add interval type in communication component
    validateInterval(item) {
      let interval = this.formData.interval;
      if (interval) {
        switch (item.value) {
          case 'SS': {
            // 05/31/2021 203737 SPKA-127 issue 76 Change minimum interval value for "Seconds" from 30 to 10. (validation allow 10~59 seconds)
            if (interval < 10 || interval > 59) {
              return this.$t('msg.communications.validateInterval', ['10', '59', 'seconds']);
            }
            break;
          }
          case 'HH': {
            if (interval < 1 || interval > 24) {
              return this.$t('msg.communications.validateInterval', ['1', '24', 'hours']);
            }
            break;
          }
          default: {
            if (interval < 1 || interval > 59) {
              return this.$t('msg.communications.validateInterval', ['1', '59', 'minutes']);
            }
          }
        }
      }
      return true;
    },
  },
};
</script>
